export default {
  __name: 'FeedbackBox',
  setup(__props, {
    expose: __expose
  }) {
    __expose();
    const baseUrl = process.env.VUE_APP_FEEDBACK_URL;
    const openFeedback = () => {
      const url = `${baseUrl}?product=aippt`;
      window.open(url);
    };
    const __returned__ = {
      baseUrl,
      openFeedback
    };
    Object.defineProperty(__returned__, '__isScriptSetup', {
      enumerable: false,
      value: true
    });
    return __returned__;
  }
};